import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import Faq from '../components/faqs/Faq';
import Question from '../components/faqs/Question';
import HeaderLayout from '../components/layout/HeaderLayout';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { COMMERCE_HUB_PROFESSIONAL } from 'self-service-api/constants/UpgradeProducts';
import BannerSection from '../components/banners/BannerSection';
import PaymentsProcessorsInbound25Wrapper from '../components/commerce-hub/PaymentsProcessorsInbound25Wrapper';
import IntegrationsSection from '../components/common/IntegrationsSection';
import PhoneSupportFooter from '../components/common/PhoneSupportFooter';
import ValuePropsSection from '../components/common/ValuePropsSection';
import { CreditsCalloutSection } from '../components/common/credits-callout/CreditsCalloutSection';
import CodeSplitEnvWrapper from '../components/common/env/CodeSplitEnvWrapper';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import ProductFeatureTable from '../components/feature-table/ProductFeatureTable';
import { ProductCardContainer } from '../components/merch-card/card-containers/ProductCardContainer';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { MERCH_CARD, TRACKING_SOURCES } from '../constants/tracking/TrackingSources';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommerceHubPage = () => {
  const pageName = NavItemEnum.COMMERCE;
  const navMarkerName = `${pageName.toUpperCase()}_PAGE`;
  useDocumentTitle(pageName);
  const isMobile = useIsMobile();
  useEffect(() => {
    trackPageView({
      screen: pageName
    });
  }, [pageName]);
  const PageWrapper = ({
    children
  }) => {
    if (isMobile) {
      return /*#__PURE__*/_jsx(MobileWrapper, {
        navMarkerName: navMarkerName,
        navItem: NavItemEnum.COMMERCE,
        children: children
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: pageName,
        children: /*#__PURE__*/_jsx(ProductInfoContainer, {
          children: children
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(PageWrapper, {
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: SCREENS.COMMERCE
    }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        productLine: COMMERCE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        productLine: COMMERCE
      })]
    }), /*#__PURE__*/_jsx(ProductCardContainer, {
      screen: SCREENS.COMMERCE,
      productsToShow: ['commerce-hub-professional', 'commerce-hub-enterprise'],
      trackingSource: MERCH_CARD
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCalloutSection, {
        navItem: 'commerce'
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(ProductFeatureTable, {
        productLine: 'COMMERCE' // TODO: fix this for Inbound 25
        ,
        highlightedProducts: ['commerce-hub-professional', 'commerce-hub-enterprise'],
        screen: SCREENS.COMMERCE
      }, `commerce`)
    }), /*#__PURE__*/_jsx(PaymentsProcessorsInbound25Wrapper, {}), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/company-proof/CompanyProof`),
      publicComponentProps: {
        tab: 'enterprise'
      }
    }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/case-studies/CaseStudies`),
      publicComponentProps: {
        productLine: 'COMMERCE',
        tab: 'starter'
      }
    }), /*#__PURE__*/_jsx(ValuePropsSection, {}), /*#__PURE__*/_jsx(Faq, {
      children: FaqsConfig[pageName.toLowerCase()].map(_ref => {
        let {
            questionKey
          } = _ref,
          passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
        return /*#__PURE__*/_jsx(Question, Object.assign({
          questionKey: questionKey
        }, passthroughOptions), questionKey);
      })
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: TRACKING_SOURCES.COMMERCE_FOOTER,
      screen: SCREENS.COMMERCE,
      upgradeProduct: COMMERCE_HUB_PROFESSIONAL
    })]
  });
};
export default CommerceHubPage;